import './section-heading.css'

/**
 * SectionHeading — eyebrow + title + optional subtitle.
 * Replaces the inlined `<span className="mono-label"> + <h2> + <p>` pattern
 * that's currently repeated dozens of times across the public pages.
 *
 * Props:
 *   eyebrow:  short mono-label text (e.g. "what is postpaid")
 *   title:    string or node
 *   subtitle: optional supporting line
 *   align:    'center' | 'left'  (default 'center')
 *   tone:     'light' | 'dark'   (default 'light' — switch on dark sections)
 */
export default function SectionHeading({
    eyebrow,
    title,
    subtitle,
    align = 'center',
    tone = 'light',
}) {
    return (
        <header className={`section-heading section-heading--${align} section-heading--${tone}`}>
            {eyebrow && <span className="section-heading__eyebrow">{eyebrow}</span>}
            <h2 className="section-heading__title">{title}</h2>
            {subtitle && <p className="section-heading__subtitle">{subtitle}</p>}
        </header>
    )
}
